module.exports = __webpack_public_path__ + "static/media/walk_kids_important.39db5113.svg";